import { noop as o } from "./utilities.js";
class t {
  wsUrl;
  ws;
  isOpen = !1;
  handleMessage;
  retryTimeout = 250;
  reconnectAttempts = 0;
  maxRetry = 5;
  reConnectOnClose = !1;
  static instance;
  constructor(e, s) {
    if (t.instance)
      return t.instance;
    if (t.instance = this, !e)
      throw new Error("No websocket url passed through!");
    this.wsUrl = e, this.reConnectOnClose = typeof s.reConnectOnClose == "boolean" ? s.reConnectOnClose : !1, this.handleMessage = typeof s.onMessage == "function" ? s.onMessage : o;
  }
  async connect() {
    if (t.instance?.ws)
      return t.instance;
    try {
      return this.ws = new WebSocket(this.wsUrl), this.ws.addEventListener("open", () => {
        this.isOpen = !0;
      }), this.ws.addEventListener("message", (e) => {
        this.handleMessage(e.data);
      }), this.ws.addEventListener("close", (e) => {
        this.isOpen = !1, this.reconnectAttempts += 1, this.ws = void 0, this.reConnectOnClose && this.reconnectAttempts <= this.maxRetry && (this.retryTimeout = Math.min(1e4, this.retryTimeout + this.retryTimeout * this.reconnectAttempts), console.log(`Socket is closed. Attempting to reconnect in ${this.retryTimeout}...`, e.reason), setTimeout(() => {
          this.connect();
        }, this.retryTimeout));
      }), this.ws.addEventListener("error", (e) => {
        console.error("Socket encountered error: ", e, "Closing socket..."), this.ws?.close();
      }), await i(this.ws, this.ws.OPEN), this;
    } catch {
      console.log("Error connectiing to websocket");
    }
  }
  sendMessage(e) {
    console.log(`Connection sending message to channel: ${JSON.stringify(e)}`), this.ws?.send(JSON.stringify({ ...e })), console.log("message sent!");
  }
  close() {
    this.ws?.close(), this.isOpen = !1, this.ws = void 0;
  }
  static clean() {
    t.instance?.close(), t.instance = void 0;
  }
}
function i(n, e) {
  return new Promise(function(s) {
    setTimeout(function() {
      n.readyState === e ? s(!0) : i(n, e).then(s);
    }, 5);
  });
}
export {
  t as Connection,
  i as waitForSocketState
};
